<template>
  <div class="yujianfenzhen">
    <div v-if="showForm" class="page" :class="isLogin ? 'no-roll' : ''">
      <YujianfenzhenForm />
    </div>
    <YujianfenzhenItem v-else :list="listData" />
  </div>
</template>
<script>
import YujianfenzhenItem from './components/yujianfenzhenItem.vue'
import YujianfenzhenForm from './components/yujianfenzhenForm.vue'
export default {
  name: 'Yujianfenzhen',
  components: {
    YujianfenzhenItem,
    YujianfenzhenForm
  },
  data() {
    return {
      listData: [],
      isLogin: false,
      showForm: false,
      userId: '',
      id: '',
      time: ''
    }
  },
  watch: {
    $route: function() {
      this.$router.go(0)
    }
  },
  created() {
    // ?openid=o1P4a5qxie1OuPDjqgtauz_Q6CwI
    this.url = `${window.location.protocol}//${window.location.host}/yujianfenzhen`
    this.time = this.$utils.dateFormat('YYYY-mm-dd', new Date())
    const userInfo = localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo'))
    const itemId = this.$route.query && this.$route.query.id
    const appletsId = localStorage.getItem('openId') || this.$route.query.openid

    if (this.$route.query.openid) {
      localStorage.setItem('openId', this.$route.query.openid)
    }

    if (!appletsId && !userInfo) {
      this.wechatAuthorize()
    }

    if (itemId) {
      this.itemId = itemId
    }

    if (userInfo) {
      this.userId = userInfo.id
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    /**
     * 获取openid
     */
    wechatAuthorize() {
      this.$Apis.wechatAuthorize({ returnUrl: `${this.url}` }).then(res => {
        if (res.code === 200) {
          window.location.href = res.data.url
        } else {
          this.$toast('请重新进入')
        }
      }).catch((err) => {
        this.$toast('服务器错误', JSON.stringify(err))
      })
    },

    getList() {
      const obj = {
        patientId: this.userId,
        startTime: `${this.time} 00:00:00`,
        endTime: `${this.time} 23:59:59`
      }
      this.$Apis.precheckGetList(obj).then(res => {
        if (res.code === 200) {
          this.listData = res.data
        }
      })
    },
    toDetail() {}
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
</style>
